import React, { useState } from 'react';
import { Moon, Sun, Bell, BellOff, Image } from 'lucide-react';
import { toast } from 'sonner';
import { useTheme } from '../contexts/ThemeContext';

export default function Settings() {
  const { theme, toggleTheme, isDark } = useTheme();
  const [notifications, setNotifications] = useState(true);
  const [branding, setBranding] = useState(false);

  const handleToggle = (setting, value, name) => {
    setting(value);
    toast.success(`${name} ${value ? 'enabled' : 'disabled'}`);
  };

  const handleThemeToggle = () => {
    toggleTheme();
    toast.success(`${theme === 'dark' ? 'Light' : 'Dark'} mode enabled`);
  };

  return (
    <div className="page-container" data-testid="settings-page">
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Configure application preferences</p>
      </div>

      <div className="settings-container">
        <div className="setting-item">
          <div className="setting-info">
            {isDark ? <Moon className="setting-icon" /> : <Sun className="setting-icon" />}
            <div>
              <h3 className="setting-title">Theme</h3>
              <p className="setting-description">Toggle dark/light theme</p>
            </div>
          </div>
          <label className="toggle-switch" data-testid="dark-mode-toggle">
            <input 
              type="checkbox" 
              checked={isDark}
              onChange={handleThemeToggle}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div className="setting-info">
            {notifications ? <Bell className="setting-icon" /> : <BellOff className="setting-icon" />}
            <div>
              <h3 className="setting-title">Notifications</h3>
              <p className="setting-description">Enable push notifications</p>
            </div>
          </div>
          <label className="toggle-switch" data-testid="notifications-toggle">
            <input 
              type="checkbox" 
              checked={notifications}
              onChange={(e) => handleToggle(setNotifications, e.target.checked, 'Notifications')}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div className="setting-info">
            <Image className="setting-icon" />
            <div>
              <h3 className="setting-title">Custom Branding</h3>
              <p className="setting-description">Use custom logo and colors</p>
            </div>
          </div>
          <label className="toggle-switch" data-testid="branding-toggle">
            <input 
              type="checkbox" 
              checked={branding}
              onChange={(e) => handleToggle(setBranding, e.target.checked, 'Custom branding')}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
}
